import { PROYECT, api_get } from "services/api";

const accountingAccountUrl = `${process.env.REACT_APP_URL}${PROYECT}/accounting_account`;

/**
 * Obtiene las cuentas contables de una planta desde el backend y normaliza
 * la respuesta a un arreglo.
 *
 * Encapsula únicamente la llamada HTTP (endpoint + normalización), sin
 * despachar acciones ni loaders. Las features de Cuenta Contable y Relación
 * de Cuenta Contable la reutilizan manteniendo cada una su propio type,
 * loading y slice de Redux.
 *
 * @param {String} stationId - Id de la planta.
 * @returns {Promise<Array>} Lista de cuentas contables (arreglo vacío si la respuesta no es un arreglo).
 */
export const fetchAccountsByStation = async (stationId) => {
  const resp = await api_get(`${accountingAccountUrl}/by-station/${stationId}`);
  return Array.isArray(resp) ? resp : [];
};
